module.exports = __webpack_public_path__ + "img/Fquiz.be1a0a2f.jpg";